/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { LinkControllerPincodeAuthenticateDto } from '../models/LinkControllerPincodeAuthenticateDto';
import type { PinValidationCommandResponse } from '../models/PinValidationCommandResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import { StatusDTO, StatusResponse } from '../models/StatusDTO';
@Injectable({
    providedIn: 'root',
})
export class LinkApiService {
    constructor(public readonly http: HttpClient) { }
    /**
     * @param requestBody
     * @returns PinValidationCommandResponse OK
     * @throws ApiError
     */
    public postApiV10Validate(
        requestBody?: LinkControllerPincodeAuthenticateDto,
    ): Observable<PinValidationCommandResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v1.0/validate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    public postApiV10Status(
        requestBody?: StatusDTO): Observable<StatusResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v1.0/status',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    public getApiV10Creator(token: string): Observable<{ creator: string }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v1.0/creator/{token}',
            path: {
                'token': token,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
}
